// src/components/admin/page-management/section-forms/GridItemForm.js
import React from 'react';

const GridItemForm = ({ content, updateContent }) => {
  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Grid/Flex Item Settings</h3>
      
      <div className="bg-white p-4 border rounded-md shadow-sm mb-4">
        <h4 className="font-medium text-gray-700 mb-3">Position & Size</h4>
        
        {/* Grid Specific Settings */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Grid Area</label>
          <input
            type="text"
            className="w-full p-2 border rounded"
            value={content?.gridArea || ''}
            onChange={(e) => updateContent('gridArea', e.target.value)}
            placeholder="header, sidebar, content, etc."
          />
          <p className="text-xs text-gray-500 mt-1">
            Name defined in grid-template-areas of parent container
          </p>
        </div>
        
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-1">Grid Column</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.gridColumn || ''}
              onChange={(e) => updateContent('gridColumn', e.target.value)}
              placeholder="1 / 3, span 2, auto"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Grid Row</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.gridRow || ''}
              onChange={(e) => updateContent('gridRow', e.target.value)}
              placeholder="1 / 3, span 2, auto"
            />
          </div>
        </div>
        
        {/* Flex Specific Settings */}
        <div className="grid grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-1">Flex Grow</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.flexGrow || ''}
              onChange={(e) => updateContent('flexGrow', e.target.value)}
              placeholder="0, 1, 2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Flex Shrink</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.flexShrink || ''}
              onChange={(e) => updateContent('flexShrink', e.target.value)}
              placeholder="0, 1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Flex Basis</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.flexBasis || ''}
              onChange={(e) => updateContent('flexBasis', e.target.value)}
              placeholder="auto, 0, 25%, 300px"
            />
          </div>
        </div>
      </div>
      
      <div className="bg-white p-4 border rounded-md shadow-sm mb-4">
        <h4 className="font-medium text-gray-700 mb-3">Alignment & Spacing</h4>
        
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-1">Align Self</label>
            <select
              className="w-full p-2 border rounded"
              value={content?.alignSelf || ''}
              onChange={(e) => updateContent('alignSelf', e.target.value)}
            >
              <option value="">Default</option>
              <option value="flex-start">Start</option>
              <option value="center">Center</option>
              <option value="flex-end">End</option>
              <option value="stretch">Stretch</option>
              <option value="baseline">Baseline</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Justify Self</label>
            <select
              className="w-full p-2 border rounded"
              value={content?.justifySelf || ''}
              onChange={(e) => updateContent('justifySelf', e.target.value)}
            >
              <option value="">Default</option>
              <option value="start">Start</option>
              <option value="center">Center</option>
              <option value="end">End</option>
              <option value="stretch">Stretch</option>
            </select>
          </div>
        </div>
        
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-1">Margin</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.margin || ''}
              onChange={(e) => updateContent('margin', e.target.value)}
              placeholder="0, 1rem, 10px 20px"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Padding</label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={content?.padding || ''}
              onChange={(e) => updateContent('padding', e.target.value)}
              placeholder="0, 1rem, 10px 20px"
            />
          </div>
        </div>
      </div>
      
      <div className="bg-white p-4 border rounded-md shadow-sm mb-4">
        <h4 className="font-medium text-gray-700 mb-3">Display & Visibility</h4>
        
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Order</label>
          <input
            type="number"
            className="w-full p-2 border rounded"
            value={content?.order || '0'}
            onChange={(e) => updateContent('order', e.target.value)}
            placeholder="0, 1, -1"
          />
          <p className="text-xs text-gray-500 mt-1">
            Controls the order in which this item appears
          </p>
        </div>
        
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              className="mr-2"
              checked={content?.isHidden || false}
              onChange={(e) => updateContent('isHidden', e.target.checked)}
            />
            <span className="text-sm font-medium">Hide This Section</span>
          </label>
          <p className="text-xs text-gray-500 mt-1 ml-6">
            This section will be removed from the layout but can be enabled again later
          </p>
        </div>
      </div>
      
      {/* Preview Section */}
      <div className="mt-6 border-t pt-4">
        <h4 className="font-medium mb-2">Item Preview</h4>
        <div className="p-4 bg-gray-100 rounded">
          <div
            style={{
              backgroundColor: '#e0e7ff',
              padding: content?.padding || '1rem',
              margin: content?.margin || '0',
              gridArea: content?.gridArea || 'auto',
              gridColumn: content?.gridColumn || 'auto',
              gridRow: content?.gridRow || 'auto',
              flexGrow: content?.flexGrow || '0',
              flexShrink: content?.flexShrink || '1',
              flexBasis: content?.flexBasis || 'auto',
              alignSelf: content?.alignSelf || 'auto',
              justifySelf: content?.justifySelf || 'auto',
              order: content?.order || '0',
              display: content?.isHidden ? 'none' : 'block',
              minHeight: '50px',
              borderRadius: '4px',
              textAlign: 'center'
            }}
          >
            Grid/Flex Item
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridItemForm;